import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ImportJobHistoriesService {

  constructor(private http: HttpClient) {
  }

  upload(params) {
    return this.http.post<any>(`${environment.apiUrl}/imports/job-histories/upload`, params);
  }
  
  preview(params) {
    return this.http.post<any>(`${environment.apiUrl}/imports/job-histories/preview`, params);
  }

  start(params) {
    return this.http.post<any>(`${environment.apiUrl}/imports/job-histories/start`, params);
  }

  getStatus(id) {
    return this.http.get<any>(`${environment.apiUrl}/imports/job-histories/${id}/status`);
  }

  getImportsList() {
    return this.http.get<any>(`${environment.apiUrl}/imports/job-histories/list`);
  }
}
